import React from "react";
import { Box } from "@material-ui/core";

import Typography from "@mui/material/Typography";
import Markdown from "react-markdown";

type SolutionBoxProps = {
  solution: any;
};

const SolutionBox = ({ solution }: SolutionBoxProps) => {
  return (
    <>
      <Typography variant="h5" gutterBottom>
        Solution:
      </Typography>
      {solution.map((item: { content: any }, index: number) => {
        return (
          <Box style={{ margin: "30px" }}>
            <Typography variant="h5" gutterBottom>
              {`Step - ${index + 1}`}
            </Typography>
            {item.content ? (
              <Typography
                variant="body1"
                sx={{ color: "#000000", fontSize: "1.2rem" }}
              >
                <Markdown>{item.content}</Markdown>
              </Typography>
            ) : (
              // <Typography sx={{ marginBottom: 2 }}>{item.content}</Typography>
              <Typography sx={{ marginBottom: 2 }}>
                {"No Solution available"}
              </Typography>
            )}
          </Box>
        );
      })}
    </>
  );
};

export default SolutionBox;
